<template>
	<div id="ap">
		<a-layout>
			<div class="content-header">
				<a-affix :offset-top="0" style="width: 100%;">
					<a-row type="flex" justify="space-between">
						<a-col span="12">
							<common-page-btn @save="save"></common-page-btn>
						</a-col>
						<a-col span="12">
							<a-row type="flex" align="middle" justify="end" :gutter="3">
								<a-col span="12">
									<a-input v-model="param.keyword" allowClear search @pressEnter="getList"
										@on-clear="getList" placeholder="关键词查询"></a-input>
								</a-col>
								<a-col span="6" v-if="getOrganId() == 0">
									<a-select v-model="param.organId" style="width:100%" @change="doRefresh()">
										<a-select-option :value="0">系统角色</a-select-option>
										<a-select-option :value="organ.organId" v-for="(organ, index) in organList"
											:key="index">{{ organ.name }}</a-select-option>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</a-affix>
			</div>
		</a-layout>

		<a-layout>
			<a-layout-content>
				<a-table :scroll="{ x: '100%' }" :pagination="false" rowKey="roleId" :style="{ background: '#FFF' }"
					size="small" border :columns="keys" ref="list" :loading="loading" :data-source="data.records">
					<!--状态-->
					<template slot-scope="row" slot="Status">
						<template v-if="row.status == 1">
							<a-icon type="check-circle" style="color:#090" />
						</template>
						<template v-else>
							<a-icon type="stop" />
						</template>
					</template>
					<!--时长-->
					<template slot-scope="row" slot="validity">{{ row.validity }}个月</template>
					<!--操作-->
					<template slot-scope="row" slot="action">
						<a-button-group shape="circle" size="small">
							<a-tooltip title="编辑"><a-button type="link" v-has="'role:save'" icon="edit"
									@click="save(row)"></a-button></a-tooltip>
							<a-tooltip title="授权"><a-button type="link" v-has="'role:auth'" icon="check-circle"
									@click="auth(row)"></a-button></a-tooltip>
							<a-tooltip title="克隆"><a-button type="link" v-has="'role:save'" icon="copy"
									@click="$refs.roleClone._show(row.roleId)"></a-button></a-tooltip>
							<a-tooltip title="删除" v-if="row.organId > 0"><a-button type="link" v-has="'role:del'"
									icon="delete" @click="del(row.roleId)"></a-button></a-tooltip>
						</a-button-group>
					</template>
				</a-table>
			</a-layout-content>
		</a-layout>
		<a-row>
			<a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
				<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
					@showSizeChange="setLimit" :current="data.current" />
			</a-col>
		</a-row>
		<a-back-top />
		<role-from ref="roleForm" @success="getList"></role-from>
		<role-auth ref="roleAuth"></role-auth>
		<role-clone ref="roleClone" @success="getList"></role-clone>
	</div>
</template>

<script>
import roleAuth from '@/views/system/role/roleAuth';
import roleFrom from '@/views/system/role/roleFrom';
import roleClone from './roleClone.vue';
import apiUtil from '@/common/apiUtil'
import utils from '@/common/utils';
export default {
	components: { roleFrom, roleAuth, roleClone },
	data() {
		return {
			loading: false,
			data: [],
			organList: apiUtil.getOrganList(),
			param: {
				page: 1,
				limit: 20,
				organId: apiUtil.getOrganId(),
				keyword: ''
			},
			keys: [
				{ title: 'ID', dataIndex: 'roleId', width: 100, align: 'center', fixed: 'left' },
				{ title: '名称', dataIndex: 'name', width: 160, align: 'center', ellipsis: true },
				{ title: '描述', dataIndex: 'description', ellipsis: true },
				{ title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
			]
		};
	},
	created() {
		this.getList();
	},
	mounted() {
		console.log(typeof apiUtil.getOrganId())
	},
	methods: {
		...apiUtil,
		//删除
		del(id) {
			this.utils.confirm('删除后无法恢复，是否确认?').then(() => {
				utils.showSpin();
				this.http.delete('/platform/role/del/' + id).then(ret => {
					if (ret.code == 200) {
						this.utils.success('操作成功！').then(() => {
							this.getList();
						});
					}
				});
			});
		},
		//添加修改页面
		save(row) {
			this.$refs.roleForm._show(row ? row : null);
		},
		auth(row) {
			this.$refs.roleAuth._show(row.roleId);
		},
		doRefresh() {
			this.param.page = 1;
			this.getList();
		},
		// 获取数据
		getList() {
			this.utils.loading();
			this.loading = true;
			this.http
				.get('/platform/role/list', this.param)
				.then(ret => {
					this.data = ret.data;
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
				});
		},
		//设置每页的显示条数
		setLimit(current, limit) {
			this.param.page = 1;
			this.param.limit = limit;
			this.getList();
		},
		//页码切换
		getNext(page) {
			this.param.page = page;
			this.getList();
		}
	}
};
</script>

<style scoped></style>
